import { boot } from 'quasar/wrappers'

export default boot(({ store }) => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : null
  store.dispatch('branding/initBranding', hostname)
})
